// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"47":"client","328":"admin","818":"auth"}[chunkId] || chunkId) + "." + {"47":"34e1e980","328":"9b969e26","386":"dc22474c","818":"3f5fdac8"}[chunkId] + ".js";
};